//@ts-nocheck

import axios from "@/plugins/axios.js";
//import store from "../store";

export default {
  //New functions should ALWAYS come on top here for easy updates

  //last compare and update below.
  updateField(table, column, value, id) {
    axios.postDataWithToken(
      "/auth/update-item",
      { table, column, id, value },
      localStorage.getItem("token")
    );
  },
  async getColumnsForSelectedTable(table) {
    const columns = await axios.postDataWithToken(
      "/auth/get-table-columns",
      {
        table,
      },
      localStorage.getItem("token")
    );
    return columns;
  },

  async getForeignTableData(table, column, branchID = null) {
    if (table) {
      const rowData = await axios.postDataWithToken(
        "/auth/get-foreign-key-data",
        { table, column: branchID },
        localStorage.getItem("token")
      );
      return rowData;
    } else {
      return [];
    }
  },
  async getForeignFieldValue(table, foreignID) {
    const name = await axios.postDataWithToken(
      "/auth/get-foreign-field-value",
      {
        table,
        foreignID,
      },
      localStorage.getItem("token")
    );
    return name;
  },
  convertArrayToObject(arrayData) {
    const obj = {};
    if (arrayData.length > 0) {
      arrayData.forEach((data) => {
        obj[data] = null;
      });
      return obj;
    } else {
      return null;
    }
  },
};
